import { getCountryAndLanguage } from './localization';

export function getAciActionUrl() {
  const { countryCode, languageCode } = getCountryAndLanguage();

  return `${window.location.origin}/${countryCode}/${languageCode}/payments/payorder/?processing=true`;
}
